//changed due to package upgrade
import React from 'react';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import { Box, Divider, Grid, Typography } from '@mui/material';
import jwtAxios from '@projectK/services/auth/JWT';
import AppScrollbar from '@projectK/components/AppScrollbar';
import AppLoader from '@projectK/components/AppLoader';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import AppCard from '@projectK/components/AppCard';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import AppInfoView from '@projectK/components/AppInfoView';
import { useTheme } from '@mui/system';
import '../../../../assets/styles/activities.css';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import PropTypes from 'prop-types';
import { WaitListMain } from '@projectK/MainComponents';
import { useToast } from '@projectK/context/ToastProvider';
import { formatStartDate, formatTime } from '@projectK/modules/apps/DateFormat';

const WaitList = ({
  waitListData,
  loading,
  fetchWaitList,
  fetchActivitySessions,
  fetchUserProduct,
  setLoading,
}) => {
  const showToast = useToast();
  const { isMobile, mobileMode } = useMobileSettings();
  const companyTheme = CompanyTheme();
  const theme = useTheme();
  const { user } = useAuthUser();
  const infoViewActionsContext = useInfoViewActionsContext();

  const handleCancelUp = async (
    ids,
    userId,
    activity_session_id,
    product_id,
  ) => {
    try {
      setLoading(true);
      // Make the Delete request using jwtAxios
      await jwtAxios.delete(`/user-waitlist/${ids}`, {
        params: {
          user_id: userId,
          activity_session_id: activity_session_id,
          product_id: product_id,
        },
      });
      setLoading(false);
      fetchWaitList();
      fetchActivitySessions();
      if (!isMobile) {
        fetchUserProduct();
        infoViewActionsContext.showMessage(`Cancelled session successfully`);
      } else {
        showToast('Cancelled session successfully.', 'success', mobileMode);
      }
    } catch (error) {
      setLoading(false);
      if (isMobile) {
        showToast(error?.response?.data?.error, 'error', mobileMode);
      } else {
        infoViewActionsContext.fetchError(error?.response?.data?.error);
      }
    }
  };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  function getTruncatedAddressTitle(data) {
    const address = data?.address ?? '';
    const locationName = data?.location_name ?? '';
    return `${address}${locationName}`.substring(0, 50);
  }
  const renderWaitListContent = () => {
    if (loading) {
      return <AppLoader />;
    }

    if (!waitListData || waitListData.length <= 0) {
      return (
        <Box
          sx={{
            textAlign: 'center',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            padding: '20px',
          }}
        >
          <CalendarMonthIcon sx={{ fontSize: 40, marginBottom: 6 }} />
          <Typography variant='body1' sx={{ fontWeight: 'bold', fontSize: 18 }}>
            No waitlist data
          </Typography>
        </Box>
      );
    }

    return (
      <Grid
        container
        spacing={2}
        className={
          isMobile ? 'activity-session my-shedule' : 'activity-session'
        }
      >
        {waitListData?.map((data) => {
          const truncatedAddressTitle = getTruncatedAddressTitle(data);
          const truncatedResourceTitle = data?.resource_name
            ? data.resource_name.substring(0, 50)
            : null;
          return (
            <Grid  key={data.id} size={{...responsiveSize}}>
              <WaitListMain
                user={user}
                data={data}
                theme={theme}
                formatStartDate={formatStartDate}
                formatTime={formatTime}
                truncatedAddressTitle={truncatedAddressTitle}
                truncatedResourceTitle={truncatedResourceTitle}
                handleCancelUp={handleCancelUp}
                companyTheme={companyTheme}
                loading={loading}
              />
            </Grid>
          );
        })}
      </Grid>
    );
  };

  const responsiveSize = { xs: 12, md: 6, lg: 6, xl: 3 };
  return (
    <AppCard>
      <Typography
        variant='h4'
        sx={{
          marginBottom: 2,
          color: companyTheme ? companyTheme.primary.main : 'text.primary',
        }}
      >
        Waitlist
      </Typography>
      <Divider sx={{ my: 2 }} />
      {isMobile ? (
        renderWaitListContent()
      ) : (
        <AppScrollbar className='scroll-products'>
          {renderWaitListContent()}
        </AppScrollbar>
      )}

      <AppInfoView />
    </AppCard>
  );
};
export default WaitList;
WaitList.propTypes = {
  waitListData: PropTypes.array,
  loading: PropTypes.bool,
  fetchWaitList: PropTypes.func,
  fetchActivitySessions: PropTypes.func,
  fetchUserProduct: PropTypes.func,
  setLoading: PropTypes.func,
};
